import StyleSheetRW from 'core/StyleSheetRW';
import React from 'react';
import { Dimensions } from 'react-native';

interface DialogProps {
  message: string;
  onDialogClose?: () => void;
  confirm?: boolean
  isDialogVisible: boolean;
  handleDialogConfirm?: () => void;
  title?: string
  confirmText?: string
  cancelText?: string
}
const SCALE = 0.85;
const Dialog: React.FC<DialogProps> = ({ message, onDialogClose, confirm, isDialogVisible, handleDialogConfirm, title , confirmText, cancelText}) => {

  if (!isDialogVisible) return null;

  const screenWidth = Dimensions.get('window').width;
  const mobileDialogStyle = { ...styles.toast, width: screenWidth < 600 ? "248px" : `${441 * SCALE}px`, alignItems: screenWidth < 600 ? "center" : "", }
  const mobileDialogButtonStyle = { ...styles.button, right: !confirm && screenWidth < 600 ? '30%' : "5%", }
  if (confirm && screenWidth < 600) {
    mobileDialogButtonStyle.right = '7%';
  } else if (confirm && screenWidth > 600) {
    mobileDialogButtonStyle.right = '5%';
  }
  const mobileDialogButtone2Style = { ...styles.button2, right: screenWidth < 600 ? '50%' : "30%" }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignSelf: 'center' }}>
      {isDialogVisible && <div className="backdrop" style={styles.backdrop}></div>}
      <div style={mobileDialogStyle}>
        <h2 style={styles.heading}>
          {title ? title : confirm ? "Confirm ?" : "Alert"}
        </h2>
        <p style={styles.message}>{message}</p>
        {confirm &&
          <button style={mobileDialogButtone2Style} onClick={onDialogClose}>{
            cancelText ? cancelText : "Cancel"
          }</button>

        }
        <button style={mobileDialogButtonStyle} onClick={() => {

          if (handleDialogConfirm) {
            handleDialogConfirm()
          }
          else {
            onDialogClose()
          }
        }}>{
            confirmText ? confirmText : "Okay"
          }</button>
      </div>
    </div>
  );
};

export default Dialog;

const styles = StyleSheetRW.create(() => ({
  toast: {
    position: 'absolute',
    top: "40%",
    bottom: "40%",
    left: "50%",
    transform: "translateX(-50%)",

    display: "flex",
    flexDirection: "column",
    backgroundColor: '#ffffff',
    padding: '10px 20px',
    borderRadius: 24,
    opacity: 1,
    transition: 'opacity 0.3s ease',
    zIndex: 1000,
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
    alignSelf: 'center',
    marginBottom: '40px',
    height: `${214 * SCALE}px`
  },
  button: {
    position: "absolute",
    backgroundColor: '#2F4858',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    padding: '5px 10px',
    marginLeft: '10px',
    borderRadius: 30,
    height: "40px",
    width: "102px",
    bottom: 15,

  },
  button2: {
    position: "absolute",
    backgroundColor: '#2F4858',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    padding: '5px 10px',
    marginLeft: '10px',
    borderRadius: 30,
    height: "40px",
    width: "102px",
    bottom: 15,
    marginRight: 20,
    opacity: 0.9
  },
  message: {

    color: "#2F4858",
    fontSize: 16,
    fontWeight: "300",
    fontFamily: "Outfit",
    textAlign: "justify",
    margin: '10px 0px 0px 2px',

  },
  // Add a class to hide other elements when the toast appears
  hideOtherElements: {
    display: 'none',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(50, 50, 50, 0.5)',// Adjust opacity to change the dullness
    zIndex: 999,
  },
  heading: {
    color: "#2F4858",
    fontSize: 24,
    fontWeight: "700",
    margin: '10px 0px 0px 0px',

    fontFamily: "Outfit",
  }
}));